"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.referendums = referendums;

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var _drr = require("../util/drr");

var _referendumInfos = require("./referendumInfos");

// Copyright 2017-2019 @polkadot/api-derive authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
function referendums(api) {
  return () => (0, _rxjs.combineLatest)([api.query.democracy.nextTally(), api.query.democracy.referendumCount()]).pipe((0, _operators.switchMap)((_ref) => {
    let [nextTally, referendumCount] = _ref;
    return referendumCount && nextTally && referendumCount.gt(nextTally) && referendumCount.gtn(0) ? (0, _referendumInfos.referendumInfos)(api)([...Array(referendumCount.sub(nextTally).toNumber())].map((_, i) => nextTally.addn(i))) : (0, _rxjs.of)([]);
  }), (0, _drr.drr)());
}